import React from "react";
import { Route, Switch, useRouteMatch } from "react-router";

import { Row } from "antd";

import VersionList from "./VersionList";
import VersionEditor from "./VersionEditor";

const WhatsNewApp = () => {
	let { path } = useRouteMatch();

	return (
		<Row
			style={{
				width: "100%",
				padding: "40px 25px 70px",
				margin: "60px auto 20px",
				backgroundColor: "#FAFAFA",
			}}
			gutter={[12, 48]}>
			<Switch>
				<Route exact path={`${path}`} component={VersionList} />
				<Route exact path={`${path}/create`} component={({ ...props }) => <VersionEditor {...props} create={true} />} />
				<Route exact path={`${path}/:versionID`} component={VersionEditor} />
				<Route path="*" component={() => <>404 NOT FOUND</>}></Route>
			</Switch>
		</Row>
	);
};

export default WhatsNewApp;
